/* Motion stays decorative: links and product controls work before this loads. */
(function () {
  function init(root) {
    if (!root || root.dataset.tgwMotionReady === 'true') return;
    root.dataset.tgwMotionReady = 'true';

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduced.matches || !('IntersectionObserver' in window)) return;

    var targets = root.querySelectorAll('.tgw-home__section-head,.tgw-home__builder-copy,.tgw-home__builder-stage,.tgw-home__story');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('tgw-is-visible');
          observer.unobserve(entry.target);
        } else {
          entry.target.classList.add('tgw-will-reveal');
        }
      });
    }, { threshold: .1, rootMargin: '0px 0px -32px 0px' });

    // IntersectionObserver reports visibility without forced layout reads.
    targets.forEach(function (target) { observer.observe(target); });
  }

  function initAll() {
    document.querySelectorAll('.tgw-home').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
